import { useReducer } from 'react'

import _ from 'lodash'

export type categoryNodeTypes = Record<string, Set<string>>
export type dispatcherCategoryNodeType = (action: ActionsWithValue | ActionsWithoutValue) => void

type value = {
  category: string
  subcategories: string[]
}

type ActionsWithValue = {
  type: 'ADD' | 'DELETE'
  value: value
}

type ActionsWithoutValue = {
  type: 'FLUSH'
}

const reducer = (state: categoryNodeTypes, action: ActionsWithValue | ActionsWithoutValue) => {
  switch (action.type) {
    case 'ADD':
      const newCategory: categoryNodeTypes = {}

      newCategory[action.value.category] = new Set([
        ..._.compact(['root', ...action.value.subcategories]),
        ...(state[action.value.category] || []),
      ])

      return { ...state, ...newCategory }
    case 'DELETE':
      const subcategories = action.value.subcategories || []
      const newCategories = _.cloneDeep(state)

      if (newCategories[action.value.category] && subcategories.length) {
        subcategories.forEach((subcategory) =>
          newCategories[action.value.category]?.delete(subcategory)
        )
      }

      return newCategories
    case 'FLUSH':
      return {}
  }
}

const useCategoryNodes = () => {
  const [state, dispatch] = useReducer(reducer, {})

  return [state, dispatch] as const
}

export default useCategoryNodes
